import Entities from 'STORE';
import { ClientConfigStoreKey } from 'STORE/ClientConfig/ClientConfig';

export function openAdminPanel(): void {
  const adminUrl = Entities.clientConfig.getConfig(ClientConfigStoreKey.AdminAuthUrlBase);
  const currentUserEmail = Entities.usersStore.Me.email;

  if (!adminUrl || !currentUserEmail) {
    return;
  }

  const redirectUrl = new URL(adminUrl);
  redirectUrl.searchParams.set('login_hint', currentUserEmail);
  window.open(redirectUrl.toString(), '_blank', 'noreferrer');
}
